module.exports = __webpack_public_path__ + "static/poster-05f4f35a01ce6e08800092f04341330b.jpg";